/* ============================================================
   HIT: camadas (painel de filtro, gaveta da sacola, modal).
   Portado de prototipo.html, linhas 1145-1195, como módulo único:

     window.HitCamadas = { abrir(el, origem), fechar(el) }

   Uma camada por vez. Aberta, ela trava a rolagem do fundo, deixa o fundo inerte (sem foco, clique nem leitor de tela),
   prende o foco (Tab e Shift+Tab giram dentro dela), fecha com Esc ou com clique no véu, e devolve o
   foco à origem (o botão que a abriu, o que está visível).
   TODO focus() usa preventScroll:true. Aprendizado do protótipo: um painel
   sem isso arremessava a página ao topo ao abrir.

   Contrato de marcação (o CSS de cada camada é de quem a usa):
   - a camada é role="dialog" com aria-modal="true" e aria-labelledby apontando para o título dela;
   - fechada, o CSS dela usa visibility:hidden (some da árvore de acessibilidade e do Tab; o foco
     inicial e o foco preso dependem disso para não pegar itens que não se veem);
   - a camada abre com a classe "on" e aria-hidden="false"; fecha tirando as duas;
   - aberta, a camada ganha tabindex="-1" (se ainda não tinha; sai ao fechar). Sem isso, clicar num texto
     dela, dentro do <main tabindex="-1">, focaria o main (fora da camada) e o foco seria arrancado do clique.
     O CSS dela (hit-base.css) tira o contorno desse foco por clique;
   - quem tem aria-controls="<id da camada>" ganha aria-expanded true/false;
   - o foco inicial vai para [data-camada-foco], senão para ".fechar", senão para o primeiro item focável;
   - o véu (.veu, hit-base.css) é #veu, criado aqui se a página não tiver um;
   - o fundo é tudo que leva o atributo data-fundo (cabeçalho, conteúdo, rodapé, barra de baixo, botão do WhatsApp): ganha inert
     com a camada aberta e perde ao fechar (o #raiz.inert do protótipo). Só desfaz o que ela mesma pôs, e nunca toca em quem contém a camada.
   Eventos, para quem precisa reagir ao fechamento por Esc ou véu (o protótipo chamava
   fecharPainel/fecharSacola direto): "hit:camada-abriu" e "hit:camada-fechou", no próprio
   elemento da camada, com bolha. detail.motivo no fechamento: "fechar" ou "substituida".
   ============================================================ */
(function () {
  'use strict';

  if (window.HitCamadas) return;

  var CLASSE_ABERTA = 'on';
  var FOCAVEIS = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),' +
    'select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  var atual = null;   // { el, origem, tabindexPosto, fundo } da camada aberta; null quando não há
  var trava = null;   // { y } enquanto a rolagem do fundo está travada
  var veu = null;

  /* ---------- foco ---------- */
  function focar(el) {
    if (el && el.isConnected && typeof el.focus === 'function') el.focus({ preventScroll: true });
  }

  function visivel(el) {
    return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  }

  // o seletor só acha candidatos; o estado real decide: tabindex="-1" (a[href] com tabindex negativo)
  // e controle em fieldset desabilitado não recebem Tab, então não podem ser o "último" da camada
  function focaveis(el) {
    return Array.prototype.filter.call(el.querySelectorAll(FOCAVEIS), function (x) {
      return x.tabIndex >= 0 && !x.matches(':disabled') && visivel(x);
    });
  }

  function focoInicial(el) {
    var alvo = el.querySelector('[data-camada-foco], .fechar');
    if (!alvo || !visivel(alvo)) alvo = focaveis(el)[0];
    // camada sem nada focável: o foco fica nela mesma (abrir() já deu a ela o tabindex), para o Esc continuar valendo
    focar(alvo || el);
  }

  function prenderFoco(el, ev) {
    var itens = focaveis(el);
    var ativo = document.activeElement;
    var dentro = el.contains(ativo) && ativo !== el;
    if (!itens.length) { ev.preventDefault(); focar(el); return; }
    var primeiro = itens[0];
    var ultimo = itens[itens.length - 1];
    if (!dentro) { ev.preventDefault(); focar(ev.shiftKey ? ultimo : primeiro); return; }
    if (ev.shiftKey && ativo === primeiro) { ev.preventDefault(); focar(ultimo); }
    else if (!ev.shiftKey && ativo === ultimo) { ev.preventDefault(); focar(primeiro); }
  }

  /* ---------- trava de rolagem ----------
     O corpo vira position:fixed na posição em que estava; ao soltar, a página volta para ela. */
  function travar() {
    if (trava) return;
    var y = window.scrollY;
    // barra de rolagem clássica (desktop no Windows/Linux) some com o corpo fixo: compensa para o conteúdo não pular
    var barra = window.innerWidth - document.documentElement.clientWidth;
    trava = { y: y };
    Object.assign(document.body.style, { position: 'fixed', top: (-y) + 'px', left: '0', right: barra + 'px' });
  }

  function destravar() {
    if (!trava) return;
    var y = trava.y;
    trava = null;
    Object.assign(document.body.style, { position: '', top: '', left: '', right: '' });
    // forma antiga de propósito (como no protótipo): Safari antigo lança erro com { behavior: 'instant' }
    // e isso cortaria o fechar() antes de devolver o foco
    window.scrollTo(0, y);
  }

  /* ---------- marcação ---------- */
  function controles(el) {
    if (!el.id) return [];
    return document.querySelectorAll('[aria-controls~="' + CSS.escape(el.id) + '"]');
  }

  function marcar(el, aberta) {
    el.classList.toggle(CLASSE_ABERTA, aberta);
    el.setAttribute('aria-hidden', aberta ? 'false' : 'true');
    controles(el).forEach(function (c) { c.setAttribute('aria-expanded', aberta ? 'true' : 'false'); });
  }

  // a camada precisa poder receber foco por clique (ver o contrato); só desfaz o que ela mesma pôs
  function darTabindex(el) {
    if (el.hasAttribute('tabindex')) return false;
    el.setAttribute('tabindex', '-1');
    return true;
  }

  function soltarTabindex(registro) {
    if (registro.tabindexPosto) registro.el.removeAttribute('tabindex');
  }

  // fundo inerte: o que leva data-fundo, menos quem contém a camada e quem já estava inerte (esse não é nosso para soltar)
  function inertarFundo(el) {
    return Array.prototype.filter.call(document.querySelectorAll('[data-fundo]'), function (x) {
      return !x.contains(el) && !x.hasAttribute('inert');
    }).map(function (x) {
      x.setAttribute('inert', '');
      return x;
    });
  }

  function soltarFundo(registro) {
    registro.fundo.forEach(function (x) { x.removeAttribute('inert'); });
  }

  function obterVeu() {
    if (veu && veu.isConnected) return veu;
    veu = document.getElementById('veu');
    if (!veu) {
      veu = document.createElement('div');
      veu.className = 'veu';
      veu.id = 'veu';
      document.body.appendChild(veu);
    }
    return veu;
  }

  function emitir(el, nome, detalhe) {
    el.dispatchEvent(new CustomEvent(nome, { bubbles: true, detail: detalhe || {} }));
  }

  /* ---------- API ---------- */
  function abrir(el, origem) {
    if (!el || (atual && atual.el === el)) return;
    var volta = origem || document.activeElement;
    var fundo = [];
    if (atual) {
      // uma camada por vez: a anterior sai sem soltar a trava nem mexer no foco
      var anterior = atual;
      // origem dentro da camada que vai sumir: o foco volta para onde ela mesma voltaria
      if (anterior.el.contains(volta)) volta = anterior.origem;
      atual = null;
      // o fundo continua inerte: passa para a camada nova, que só soma o que faltar (e solta o que a contém, se houver)
      fundo = anterior.fundo.filter(function (x) {
        if (!x.contains(el)) return true;
        x.removeAttribute('inert');
        return false;
      });
      marcar(anterior.el, false);
      soltarTabindex(anterior);
      emitir(anterior.el, 'hit:camada-fechou', { motivo: 'substituida' });
    }
    travar();
    atual = { el: el, origem: volta, tabindexPosto: darTabindex(el), fundo: fundo.concat(inertarFundo(el)) };
    marcar(el, true);
    obterVeu().classList.add(CLASSE_ABERTA);
    focoInicial(el);
    emitir(el, 'hit:camada-abriu');
  }

  function fechar(el) {
    if (!atual || (el && atual.el !== el)) return;
    var fechada = atual;
    atual = null;
    marcar(fechada.el, false);
    soltarTabindex(fechada);
    soltarFundo(fechada); // antes de devolver o foco: a origem está no fundo e inerte não recebe foco
    if (veu) veu.classList.remove(CLASSE_ABERTA);
    destravar();
    emitir(fechada.el, 'hit:camada-fechou', { motivo: 'fechar' });
    focar(fechada.origem);
  }

  /* ---------- teclado, véu e foco que escapa ---------- */
  document.addEventListener('keydown', function (ev) {
    if (!atual || ev.defaultPrevented) return;
    // a camada saiu do DOM com ela aberta (um app trocou o HTML): solta a trava em vez de prender a página
    if (!atual.el.isConnected) { fechar(); return; }
    if (ev.key === 'Escape') fechar(atual.el);
    else if (ev.key === 'Tab') prenderFoco(atual.el, ev);
  });

  document.addEventListener('click', function (ev) {
    if (atual && ev.target.classList && ev.target.classList.contains('veu')) fechar(atual.el);
  });

  // foco que chega de fora (script de terceiros, clique em algo acima do véu) volta para dentro
  document.addEventListener('focusin', function (ev) {
    if (!atual) return;
    if (!atual.el.isConnected) { fechar(); return; }
    if (!atual.el.contains(ev.target)) focoInicial(atual.el);
  });

  window.HitCamadas = Object.freeze({ abrir: abrir, fechar: fechar });
})();
